import * as React from "react";
import { forwardRef } from "react";
const PencilSVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { fillRule: "evenodd", d: "M19.258 2.488a2 2 0 0 0-2.828 0L2.586 16.33A2 2 0 0 0 2 17.746v3.742a1 1 0 0 0 1 1h3.742a2 2 0 0 0 1.414-.586L22 8.058a2 2 0 0 0 0-2.828zM16.106 5.64l1.738-1.738 2.742 2.742-1.738 1.738zM14.69 7.054 4 17.746v2.742h2.742L17.434 9.796z", clipRule: "evenodd" }));
const ForwardRef = forwardRef(PencilSVG);
export default ForwardRef;
//# sourceMappingURL=Pencil.js.map